import React, { useState } from "react";
import {
  Box,
  Button,
  Typography,
  FormControlLabel,
  Switch,
  Radio,
  RadioGroup,
  FormControl,
  FormLabel,
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
  InputLabel,
} from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";
import EditIcon from "@mui/icons-material/Edit";
import "./PTStatus.css";

const PTStatus = () => {
  const [ptStatus, setPtStatus] = useState(false);
  const [editable, setEditable] = useState(false);
  const [ptStates, setPtStates] = useState("all");
  const [allowOverride, setAllowOverride] = useState(false);
  const [selectedStates, setSelectedStates] = useState([]);

  const states = ["Andhra Pradesh", "Telangana", "Karnataka", "Tamil Nadu"];

  const handleToggle = (e) => {
    setPtStatus(e.target.checked);
    if (!e.target.checked) setEditable(false);
  };

  const handleSave = () => {
    setEditable(false);
    // API call here
  };

  return (
    <Box className="pt-wrapper">
      <Box className="pt-card">
        {/* Header */}
        <Box className="pt-header">
          <Typography className="pt-title">PT Status</Typography>
          <FormControlLabel
            control={<Switch checked={ptStatus} onChange={handleToggle} />}
            label={ptStatus ? "Enabled" : "Disabled"}
            labelPlacement="start"
          />
        </Box>

        {ptStatus && (
          <Box className="pt-body">
            {/* Effective Date */}
            <Typography className="pt-date">
              Effective Date: 1 April 2020
            </Typography>

            {/* PT States */}
            <FormControl className="pt-section">
              <FormLabel className="pt-label">PT States</FormLabel>
              <RadioGroup
                row
                value={ptStates}
                onChange={(e) => setPtStates(e.target.value)}
              >
                <FormControlLabel
                  value="all"
                  control={<Radio />}
                  label="All States"
                  disabled={!editable}
                />
                <FormControlLabel
                  value="select"
                  control={<Radio />}
                  label="Select States"
                  disabled={!editable}
                />
              </RadioGroup>

              {ptStates === "select" && (
                <FormControl fullWidth className="pt-select" disabled={!editable}>
                  <InputLabel>Select States</InputLabel>
                  <Select
                    multiple
                    value={selectedStates}
                    onChange={(e) => setSelectedStates(e.target.value)}
                    renderValue={(selected) => selected.join(", ")}
                  >
                    {states.map((state) => (
                      <MenuItem key={state} value={state}>
                        <Checkbox checked={selectedStates.includes(state)} />
                        <ListItemText primary={state} />
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              )}
            </FormControl>

            {/* Override */}
            <FormControlLabel
              control={
                <Switch
                  checked={allowOverride}
                  onChange={(e) => setAllowOverride(e.target.checked)}
                  disabled={!editable}
                />
              }
              label="Allow PT Override"
              className="pt-override"
            />

            {/* Buttons */}
            <Box className="pt-actions">
              {!editable ? (
                <Button
                  variant="outlined"
                  startIcon={<EditIcon />}
                  onClick={() => setEditable(true)}
                >
                  Edit
                </Button>
              ) : (
                <>
                  <Button variant="outlined" onClick={() => setEditable(false)}>
                    Cancel
                  </Button>
                  <Button
                    variant="contained"
                    startIcon={<SaveIcon />}
                    onClick={handleSave}
                  >
                    Save
                  </Button>
                </>
              )}
            </Box>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default PTStatus;
